














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InvitedUser from "@/components/InvitedUser.vue";
import { getInvitationProgress } from "@/api";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";

@Component({
  components: {
    MyFooter,
    Rule,
    InvitedUser
  }
})
export default class My extends Vue {
  $refs!: {
    scroll: HTMLElement;
    end: HTMLElement;
  };
  @Prop({ type: Number, required: true }) actId!: number;
  loading: boolean = true;
  info: any = {
    detailPageInfo: {},
    rewards: []
  };
  @Watch("actId", { immediate: true })
  async getMineActivityInfo(actId: number) {
    this.loading = true;
    let res = await getInvitationProgress(actId);
    this.info = res;
    this.loading = false;
    if (this.info.detailPageInfo.title) {
      document.title = this.info.detailPageInfo.title;
    }
    // @ts-ignore
    this.$rulePopup({
      value: false,
      rule: this.info.detailPageInfo.rule
    });
  }
  get title() {
    console.log();
    let res = "还没有人关注呢，快去邀请关注吧~";
    if (this.info.totalNum && this.info.completedNum === this.info.totalNum) {
      res = `太棒了，你完成了关注任务`;
    } else {
      `${this.info.completedNum}人已关注，还差${this.info.totalNum -
        this.info.completedNum}人`;
    }
    return res;
  }
}
